import { Injectable } from "@angular/core";
import { SupplierFilterDto } from "@sharedcommon/model/organization/filter/supplier-filter.model";
import { SupplierDto } from "@sharedcommon/model/organization/supplier.model";
import { SharedPagedResponse } from "@sharedcommon/model/shared-paged-response.model";
import { NeqHttpClient } from "@sharedcommon/rest/http-client.config";
import { OrganizationApiUrlUtil } from "@sharedcommon/util/organization-api-url.util";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SupplierRestService {

  constructor(protected neqHttpClient: NeqHttpClient) {}
  
  /**
   * Search supplier
   * Response code 200 - filters supplier
   * Response code 500 - Error
   * HTTP GET /supplier/search
   * Java method: com.neovia.services.organization.controller.SupplierController.search()
   */
  search(filterDto: SupplierFilterDto): Observable<SharedPagedResponse<SupplierDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl("supplier/search"), data: filterDto });
  }
  
  /**
   * Get supplier by code
   * Response code 200 - obtained
   * Response code 404 - Not found
   * HTTP GET /supplier/{code}
   * Java method: com.neovia.services.organization.controller.SupplierController.getSupplier()
   */
  getByCode(code: string): Observable<SupplierDto> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl(`supplier/${code}`)});
  }

  /**
   * Search suppliers by entity codes
   * Response code 200 - paged response of suppliers
   * Response code 500 - Error
   * HTTP GET entity/{entityCode}/supplier/search
   * Java method: com.neovia.services.organization.controller.EntityController.searchSuppliersByEntityCode()
   */
  searchByEntityCode(entityCode: string, filterDto: SupplierFilterDto): Observable<SharedPagedResponse<SupplierDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: OrganizationApiUrlUtil.formatApiUrl(`entity/${entityCode}/supplier/search`), data: filterDto });
  }
}